module.exports = "<div [@dialog] *ngIf=\"visible\" class=\"dialog\">\n\n  <ng-content></ng-content>\n\n  <button *ngIf=\"closable\" (click)=\"close()\" aria-label=\"Close\" class=\"dialog__close-btn\">X</button>\n\n</div>\n\n<div *ngIf=\"visible\" class=\"overlay\" (click)=\"close()\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/modal/dialog/dialog.component.html
// module id = ../../../../../src/app/modal/dialog/dialog.component.html
// module chunks = main